import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";

export const Sheet = ({ open, onOpenChange, side = "bottom", title, children, testId, onInteractOutside }) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    <Dialog.Portal>
      <Dialog.Overlay className="sheet-overlay" />
      <Dialog.Content data-testid={testId} className={`sheet sheet-${side}`} aria-describedby={undefined} onInteractOutside={onInteractOutside}>
        <div className="flex items-center justify-between gap-4">
          <Dialog.Title className="font-serif text-xl text-tinta">{title}</Dialog.Title>
          <Dialog.Close className="icon-btn" aria-label="Cerrar" data-testid={`${testId}-close`}>
            <X size={20} strokeWidth={1.75} />
          </Dialog.Close>
        </div>
        {children}
      </Dialog.Content>
    </Dialog.Portal>
  </Dialog.Root>
);
